import axios            from 'axios';
import authHeader       from 'services/auth-header';

class CovidRiskCheckerService  {

  toggleCovid(id, params) {
    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + 'chat_sessions/' + id + '/toggle_covid', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  submitCovid(id, params) {
    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + 'chat_sessions/' + id + '/submit_covid_symptoms', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

}

export default new CovidRiskCheckerService();